<template>
    <div class="notifications" @click="openNotificationPanel">
        <a class="nav-link" role="button">
            <i class="fi fi-rr-bell"></i>
            <span class="badge bg-danger rounded-pill badge-counter">{{ unread > 0 ? (unread > 9 ? '9+' : unread) : ''}}</span>
        </a>
    </div>
</template>

<script>
import NotificationTrayItem from "../atoms/NotificationTrayItem.vue";
import Notifications from "../Organisms/Notifications.vue";
import {CHANEL_USER} from "../../../services/WebSocketsConfigs";
import {eventBus} from "../../../services/EventBus";

export default {
    name: "NotificationsTray",
    props: {
        userId: String | Number,
    },
    data() {
        return {
            page: 1,
            limit: 7,
            items: [],
            unread: '',
            notificationsPanel: null,
            types: {
                check_in: trans('general.module.notifications.type.check_in'),
                check_out: trans('general.module.notifications.type.check_out'),
                nap: trans('general.module.notifications.type.nap'),
                bathroom: trans('general.module.notifications.type.bathroom'),
                activity: trans('general.module.notifications.type.activity'),
                mood: trans('general.module.notifications.type.mood'),
                meal: trans('general.module.notifications.type.meal'),
                message: trans('general.module.notifications.type.message'),
                missing: trans('general.module.notifications.type.missing'),
                event: trans('general.module.notifications.type.event'),
            }
        }
    },
    components: {
        NotificationTrayItem
    },
    created() {
        eventBus.$on('eventDataChanged', (data) => {
            const index = this.items.findIndex(item =>
                item?.data?.data?.type === 'event' && item?.data?.data?.id === data.id
            );

            if (index !== -1) {
                this.$set(this.items[index].data, 'data', data);
            }
        });
    },
    methods: {
        load() {
            const params = {limit: this.limit, page: this.page};

            axios.get(`/notifications`, {params})
                .then((response) => {
                    let notices = response.data.data.notifications;

                    this.items = [...this.items, ...notices]

                    //modify check_out each item text
                    this.items.forEach((item, i) => {
                        if (item.data.data.type === 'check_out' && item.data.data.description != null) {
                            this.items[i].data.text = item.data.text +
                                ' (' + item.data.data.description + ')';
                        }
                    });

                    if (this.page === 1) {
                        this.unread = response.data.data.unreadCount;
                    }
                    if (notices.length < this.limit) {
                        if(this.$refs.show_more)
                        this.$refs.show_more.setAttribute('class', 'd-none');
                    }
                });
        },

        openNotificationPanel() {
            this.notificationsPanel = this.$showPanel({
                component: Notifications,
                openOn: 'right',
                width: 460,
                cssClass: 'sidePanel',
                props: {
                    notifications: this.items,
                    userId: this.userId,
                    load: this.load,
                    unread_count: this.unread
                }
            });

            this.notificationsPanel.promise.then(result => {
                this.unread = result.unread;
            });
        },

        getNotifyContent(item) {
            const types = {
                event: `<strong>${item.data.type}</strong> ${item.data.title}`
            };

            return types[item.data.type] ?? (
                this.types[item.data.type] !== undefined ?
                this.types[item.data.type] : trans('general.notifications.new')
            );
        },

        listen() {
            Echo.private(CHANEL_USER + this.userId)
                .notification((notification) => {
                    this.$notify({
                        type: 'success',
                        text: this.getNotifyContent(notification)
                    })
                    this.items = [];
                    this.page = 1;
                    this.showMoreBtn = true;
                    this.load();
                }).error((err) => {});
        },
    },
    mounted() {
        this.load();
        this.listen();
    }
}
</script>
